import { render, staticRenderFns } from "./HomeModern.vue?vue&type=template&id=02fbcfa8&scoped=true"
import script from "./HomeModern.vue?vue&type=script&lang=js"
export * from "./HomeModern.vue?vue&type=script&lang=js"
import style0 from "./HomeModern.vue?vue&type=style&index=0&id=02fbcfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../pws_portal/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fbcfa8",
  null
  
)

export default component.exports